import Dashboard from './components/DashboardPage';
import BuildUpPage from './components/BuildUpPage';
import BreakdownPage from './components/BreakdownPage';
import SearchPage from './components/SearchPage';
import ComponentsPage from './components/ComponentsPage';
import Co2Page from './components/Co2Page';
import Categories from './components/Categories';
import WeightPage from './components/WeightPage';
import SupplyRatesPage from './components/SupplyRatesPage';
import AccountPage from './components/AccountPage';
import NewMaterialPage from './components/NewMaterialPage';
import MaterialEditorPage from './components/MaterialEditorPage';
import Unauthorized from './components/Unauthorized'; 
import NewBreakdownPage from './components/NewBreakdownPage';
import NewCostPage from './components/NewCostPage';
import EditCostPage from './components/EditCostPage';
import NewCo2WeightPage from './components/NewCo2WeightPage';
import EditCo2WeightPage from './components/EditCo2WeightPage';
import NewCategoryPage from './components/NewCategoryPage';
import ManageCategoryPage from './components/ManageCategoryPage';
import EC3Page from './components/EC3Page';
import AdminUserManagement from './components/AdminUserManagement';
import SupplierDashboard from './components/SupplierDashboard';
import UserDashboard from './components/UserDashboard';
import SupplierPendingApproval from './components/SupplierPendingApproval';
import UserPendingApproval from './components/UserPendingApproval';
import LogsPage from './components/LogsPage';
import UserRegionManagement from './components/admin/UserRegionManagement';
import BuildNewCompositePage from './components/BuildNewCompositePage';
import MaterialRequestsPage from './components/MaterialRequestsPage';
import MaterialSubmissionsPage from './components/MaterialSubmissionsPage';
import NewProductPage from './components/NewProductPage';
import CompositeRequestsPage from './components/CompositeRequestsPage';
import EPDPage from './components/EPDPages';
import ComingSoon from './components/ComingSoon';
import MessagesPage from './components/MessagesPage';
import CostEditorPage from './components/CostEditorPage';
import BunningsDataPage from './components/APIs/BunningsDataPage';
import PlacemakersDataPage from './components/APIs/PlacemakersDataPage';
import NabersEpdCategoriesPage from './components/NabersEpdCategoriesPage';
import NabersRefEfPage from './components/NabersRefEfPage';
import UserAnalyticsPage from './components/UserAnalyticsPage';
import MyMaterialsPage from './components/MyMaterialsPage';
import MyTeamPage from './components/MyTeamPage';
import MyLibraryCategoriesPage from './components/MyLibraryCategoriesPage';
import MyLibraryMaterialsPage  from './components/MyLibraryMaterialsPage';
import UserLayout from './components/UserLayout';
import Calculators from './components/Calculators';
import RebarCalculator from './components/RebarCalculator';
import CompanyLogsPage from './components/CompanyLogsPage';


const routes = [
    { path: '/', element: <Dashboard /> },
    { path: '/Co2', element: <Co2Page />, protected: true, allowedRoles: ['user', 'admin'] },
    { path: '/categories', element: <Categories />, protected: true, allowedRoles: ['user','admin', 'supplier'] },
    { path: '/weight/:quantityCatId', element: <WeightPage />, protected: true, allowedRoles: ['admin'] },
    { path: '/build-up/:quantityCatId', element: <BuildUpPage />, protected: true, allowedRoles: ['user', 'admin', 'supplier'] },
    { path: '/breakdown/:quantityUnitId', element: <BreakdownPage />, protected: true, allowedRoles: ['user','admin', 'supplier'] },
    { path: '/category/:measurementUnitName', element: <NewBreakdownPage />, protected: true, allowedRoles: ['admin'] },
    { path: '/search', element: <SearchPage />, protected: true, allowedRoles: ['user', 'admin', 'supplier'] },
    { path: '/account', element: <AccountPage />, protected: true, allowedRoles: ['user', 'admin', 'supplier'] },
    { path: '/components', element: <ComponentsPage />, protected: true, allowedRoles: ['admin'] },
    { path: '/dashboard', element: <Dashboard />, protected: true, allowedRoles: ['admin'] },
    { path: '/supply-rates', element: <SupplyRatesPage />, protected: true, allowedRoles: ['admin'] },
    { path: '/newmaterial', element: <NewMaterialPage />, protected: true, allowedRoles: ['admin'] },
    { path: '/materialeditor', element: <MaterialEditorPage />, protected: true, allowedRoles: ['admin'] },
    { path: '/newbreakdown', element: <NewBreakdownPage />, protected: true, allowedRoles: ['admin'] },
    { path: '/newcost', element: <NewCostPage />, protected: true, allowedRoles: ['admin'] },
    { path: '/editcost', element: <EditCostPage />, protected: true, allowedRoles: ['admin'] },
    { path: '/newCo2Weight', element: <NewCo2WeightPage />, protected: true, allowedRoles: ['admin'] },
    { path: '/editCo2Weight', element: <EditCo2WeightPage />, protected: true, allowedRoles: ['admin'] },
    { path: '/newcategory', element: <NewCategoryPage />, protected: true, allowedRoles: ['admin'] },
    { path: '/managecategory', element: <ManageCategoryPage />, protected: true, allowedRoles: ['admin'] },
    { path: '/EC3data', element: <EC3Page />, protected: true, allowedRoles: ['admin'] },
    { path: '/logs', element: <LogsPage />, protected: true, allowedRoles: ['admin'] },
    { path: '/newproduct', element: <NewProductPage />, protected: true, allowedRoles: ['admin'] },
    { path: '/admin/user-regions', element: <UserRegionManagement />, protected: true, allowedRoles: ['admin'], title: 'User Region Management'},
    { path: "/admin/composite-requests", element: <CompositeRequestsPage />, protected: true, allowedRoles: ['admin'] },
    { path: "/cost-editor", element: <CostEditorPage />, protected: true, allowedRoles: ['admin'] },
    { path: "/bunnings-routes", element: <BunningsDataPage />, protected: true, allowedRoles: ['admin'] },
    { path: "/placemakers", element: <PlacemakersDataPage />, protected: true, allowedRoles: ['admin'] },
    { path: "/nabers-epd-categories", element: <NabersEpdCategoriesPage />, protected: true, allowedRoles: ['admin'] },
    { path: "/nabers-ref-ef", element: <NabersRefEfPage />, protected: true, allowedRoles: ['admin'] },


    // 🟢 NEW USER MANAGEMENT ROUTES
    { path: '/admin/material-submissions', element: <MaterialSubmissionsPage  />, protected: true, allowedRoles: ['admin'] },
    { path: '/admin/user-management', element: <AdminUserManagement />, protected: true, allowedRoles: ['admin'] },
    { path: '/admin/user-analytics', element: <UserAnalyticsPage />, protected: true, allowedRoles: ['admin'] },
    
    // 🟢 SUPPLIER ROUTES
    { path: '/supplier/dashboard', element: <SupplierDashboard />, protected: true, allowedRoles: ['supplier'] },
    { path: '/supplier/pending-approval', element: <SupplierPendingApproval />, protected: false }, // No role check for pending users
    { path: '/supplier/my-submissions', element: <ComingSoon backTo="/supplier/dashboard"/>, protected: true, allowedRoles: ['supplier'] },
    { path: '/supplier/documentation', element: <ComingSoon backTo="/supplier/dashboard"/>, protected: true, allowedRoles: ['supplier'] },

    
    // 🟢 USER ROUTES  
    { path: '/user/dashboard', element: <UserDashboard />, protected: true, allowedRoles: ['user'] },
    { path: '/user/pending-approval', element: <UserPendingApproval />, protected: false }, 
    { path: '/unauthorized', element: <Unauthorized />, protected: false }, // Unauthorized page
    { path: '/user/epd', element: <EPDPage />, protected: true, allowedRoles: ['user'] },
    { path: '/user/reports', element: <ComingSoon backTo="/user/dashboard"/>, protected: true, allowedRoles: ['user'] },
    { path: '/user/my-composites', element: <MyMaterialsPage />, protected: true, allowedRoles: ['user'] },
    { path: '/user/my-team', element: <MyTeamPage />, protected: true, allowedRoles: ['user', 'supplier', 'admin'] },
    { path: '/user/my-library', element: <MyLibraryCategoriesPage />, protected: true, allowedRoles: ['user'] },
    { path: '/user/my-library/:categoryId', element: <MyLibraryMaterialsPage />, protected: true, allowedRoles: ['user'] },
    { path: '/user/calculator',       element: <Calculators />,      protected: true, allowedRoles: ['user', 'admin'] },
    { path: '/user/calculator/rebar', element: <RebarCalculator />,  protected: true, allowedRoles: ['user', 'admin'] },
    { path: '/user/logs',             element: <CompanyLogsPage />,  protected: true, allowedRoles: ['user'] },


    // USER / SUPPLIER 
    { path: '/composite-requests', element: <BuildNewCompositePage />, protected: true, allowedRoles: ['supplier', 'user'] },
    { path: '/messages', element: <MessagesPage />, protected: true, allowedRoles: ['user','supplier','admin'] },
    { path: '/material-requests', element: <MaterialRequestsPage />, protected: true, allowedRoles: ['supplier', 'user'] },

];

export default routes;
